import {
  JOB_BOARD_EDIT_POPUP_SEARCH_TEXT,
  JOB_BOARD_EDIT_POPUP_SET_ACTIVE_QUOTE_INDEX,
  JOB_BOARD_EDIT_POPUP_SET_IFRAME_LOADING,
  JOB_BOARD_EDIT_POPUP_SET_IFRAME_WAITING, JOB_BOARD_EDIT_POPUP_SET_IFRAME_WAITING_RECEIPT,
  JOB_BOARD_EDIT_POPUP_SET_JOB_CART_ITEMS,
  JOB_BOARD_EDIT_POPUP_SET_JOB_INFO,
  JOB_BOARD_EDIT_POPUP_USE_FAB_PRICES,
  JOB_BOARD_EDIT_POPUP_USE_TAXES,
} from "../../../constants/actionTypes";

export const setJobEditCartItems = (jobCartItems) => ({
  type: JOB_BOARD_EDIT_POPUP_SET_JOB_CART_ITEMS,
  payload: {jobCartItems}
})

export const setJobEditPopupInfo = (parsedJobData) => ({
  type: JOB_BOARD_EDIT_POPUP_SET_JOB_INFO,
  payload: parsedJobData
})

export const setJobEditPopupSearchText = (jobEditPopupSearchText) => ({
  type: JOB_BOARD_EDIT_POPUP_SEARCH_TEXT,
  payload: {jobEditPopupSearchText}
})

export const setJobEditPopupActiveQuoteIndex = (jobEditPopupActiveQuoteIndex) => ({
  type: JOB_BOARD_EDIT_POPUP_SET_ACTIVE_QUOTE_INDEX,
  payload: {jobEditPopupActiveQuoteIndex}
})

export const setJobEditPopupIframeLoading = (jobEditPopupIframeLoading) => ({
  type: JOB_BOARD_EDIT_POPUP_SET_IFRAME_LOADING,
  payload: {jobEditPopupIframeLoading}
})

export const setJobEditPopupIframeWaiting = (jobEditPopupIframeWaiting) => ({
  type: JOB_BOARD_EDIT_POPUP_SET_IFRAME_WAITING,
  payload: {jobEditPopupIframeWaiting}
});

export const setJobEditPopupIframeWaitingReceipt = (jobEditPopupIframeWaitingReceipt) => ({
  type: JOB_BOARD_EDIT_POPUP_SET_IFRAME_WAITING_RECEIPT,
  payload: {jobEditPopupIframeWaitingReceipt}
});

export const setJobUseFabricatorCostPrices = (jobUseFabricatorCostPrices) => ({
  type: JOB_BOARD_EDIT_POPUP_USE_FAB_PRICES,
  payload: {jobUseFabricatorCostPrices}
});

export const setJobUseTaxes = (jobUseTaxes) => ({
  type: JOB_BOARD_EDIT_POPUP_USE_TAXES,
  payload: {jobUseTaxes}
});
